import request from "../../../utils/wapRequest";

const url = process.env.VUE_APP_BASE_LOGIN;

const ReviewFacility = {
  get_review_facility(query) {
    return request({
      url: `${url}/services/get_review_facility`,
      method: "GET",
      params: query
    });
  },
  get_detail_facility(query) {
    return request({
      url: `${url}/services/get_detail_facility`,
      method: "GET",
      params: query
    });
  },
  get_data_post(query) {
    return request({
      url: `${url}/services/get_data_post`,
      method: "GET",
      params: query
    });
  },
  get_top_post(query) {
    return request({
      url: `${url}/services/get_top_post`,
      method: "GET",
      params: query
    });
  },
  get_detail_post(query) {
    return request({
      url: `${url}/services/get_detail_post`,
      method: "GET",
      params: query
    });
  },
  list_feedback_facility(query) {
    return request({
      url: `${url}/services/list_feedback_facility`,
      method: "GET",
      params: query
    });
  },
  send_feedback_facility(query, data) {
    return request({
      url: `${url}/services/send_feedback_facility`,
      method: "POST",
      params: query,
      data
    });
  }
};
export { ReviewFacility as default };
